// extracted by mini-css-extract-plugin
export var box = "_27-2";
export var checkboxControl = "_27-0";
export var checkboxRow = "_27-9";
export var checked = "_27-3";
export var descriptionSpacer = "_27-b";
export var disabled = "_27-4";
export var icon = "_27-7";
export var input = "_27-1";
export var labelSpacer = "_27-a";
export var medium = "_27-6";
export var small = "_27-5";
export var text = "_27-8";